import { AsapFieldsSelectFromBoxes } from './asap-fields-select-from-boxes';


export const ASAP_FIELDS_SELECT_FROM_BOXES: any[] = [AsapFieldsSelectFromBoxes];
